/**
 * Navigation Component
 *
 * @constructor
 */

const triggerHeaderDropdown = () => {
    const triggersHeaderDropdown = document.getElementsByClassName('header-dropdown-relative')

    for (let trigger of triggersHeaderDropdown) {
        trigger.addEventListener('mouseover', (event) => {
            event.preventDefault()

            const dropdownContent = trigger.querySelector('.header-dropdown-content')
            const arrow = trigger.querySelector('.header-arrow')

            dropdownContent.classList.add('header-dropdown-content-open', 'header-dropdown-content-covered')
            arrow.classList.add('header-arrow-reverse')
        })

        trigger.addEventListener('mouseleave', (event) => {
            event.preventDefault()

            const dropdownContent = trigger.querySelector('.header-dropdown-content')
            const arrow = trigger.querySelector('.header-arrow')

            dropdownContent.classList.remove('header-dropdown-content-covered')

            setTimeout(function () {
                if (!dropdownContent.classList.contains('header-dropdown-content-covered')) {
                    dropdownContent.classList.remove('header-dropdown-content-open')
                    arrow.classList.remove('header-arrow-reverse')
                }
            }, 1000)
        })
    }
}

const triggerHeaderLanguageChange = () => {
    const triggersHeaderLanguages = document.getElementsByClassName('header-layout')

    for (let trigger of triggersHeaderLanguages) {
        trigger.addEventListener('mouseover', (event) => {
            event.preventDefault()

            const arrow = trigger.querySelector('.header-layout-arrow-burger')

            trigger.classList.add('header-layout-open')
            arrow.classList.add('header-layout-open')
        })

        trigger.addEventListener('mouseleave', (event) => {
            event.preventDefault()

            const arrow = trigger.querySelector('.header-layout-arrow-burger')

            trigger.classList.remove('header-layout-open')
            arrow.classList.remove('header-layout-open')
        })
    }
}

const triggerHeaderMenuToggle = () => {
    const menuToggle = document.querySelector('.header-menu-toggle')
    const menu = menuToggle.querySelector('.header-menu')

    menuToggle.addEventListener('click', (event) => {
        event.preventDefault()

        if (menu.classList.contains('header-opened-menu')) {
            menu.classList.remove('header-opened-menu')
        } else {
            menu.classList.add('header-opened-menu')
        }
    })
}

const triggerHeaderMenuProductsOpen = () => {
    const triggerHeaderMenuProducts = document.getElementsByClassName('header-menu-link-sub')

    for (let trigger of triggerHeaderMenuProducts) {
        trigger.addEventListener('click', (event) => {
            event.preventDefault()

            const menuToggle = document.querySelector('.header-menu-toggle');
            const subMenu = menuToggle.querySelector('.header-inner-list')
            const arrow = trigger.querySelector('.header-layout-arrow-burger')

            if (subMenu.classList.contains('header-is-open-inner-list')) {
                subMenu.classList.remove('header-is-open-inner-list')
                arrow.classList.remove('header-arrow-reverse')
            } else {
                subMenu.classList.add('header-is-open-inner-list')
                arrow.classList.add('header-arrow-reverse')
            }
        })
    }
}

const onPageScroll = () => {
    window.addEventListener('scroll', () => {
        const headerContainer = document.querySelector('.header-container');
        const headerLogo = document.querySelector('.header-logo');

        if (window.scrollY > 100) {
            headerContainer.classList.add('header-scroll-container');
            headerLogo.classList.add('header-logo-scroll');
        } else {
            headerContainer.classList.remove('header-scroll-container');
            headerLogo.classList.remove('header-logo-scroll');
        }

        const arrowUpBtn = document.querySelector('.arrow-up-btn');

        if (window.pageYOffset > 800 && document.body.scrollHeight - window.pageYOffset > 1000) {
            arrowUpBtn.setAttribute('style', 'display: block');
        } else {
            arrowUpBtn.setAttribute('style', 'display: none');
        }
    });
}

const triggerArrowUpClick = () => {
    const arrowUpBtn = document.querySelector('.arrow-up-btn')

    arrowUpBtn.addEventListener('click', (event) => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    })
}

const triggerChat = () => {
    const liveChatBtns = document.getElementsByClassName('live-chat')

    for (let liveChatBtn of liveChatBtns) {
        liveChatBtn.addEventListener('click', (event) => {
            if (typeof window !== 'undefined') {
                // eslint-disable-next-line no-console
                window.Beacon ? window.Beacon('open') : console.error('Chat is not available');
            }
        })
    }
}

export default function()
{
    triggerHeaderDropdown()
    triggerHeaderLanguageChange()
    triggerHeaderMenuToggle()
    triggerHeaderMenuProductsOpen()
    onPageScroll()
    triggerArrowUpClick()
    triggerChat()
}
